import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { analyticsService } from '../services/analytics.service';

export function useInventoryAnalytics() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';

  const query = useQuery({
    queryKey: ['inventory', 'analytics', companyId],
    queryFn: () => analyticsService.fetchAnalytics(companyId),
    enabled: !!companyId,
    staleTime: 60000, // Cache for 1 minute
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
